"use client";

import { useSiteStyle, type SiteStyle } from "./style-provider";

const OPTIONS: { id: SiteStyle; label: string; short: string }[] = [
  // Cyber style parked — re-enable to restore the toggle.
  // { id: "cyber", label: "Cyber", short: "Cyber" },
  { id: "claude", label: "Claude", short: "Claude" },
];

export function StyleToggle() {
  const { style, setStyle } = useSiteStyle();

  return (
    <div
      className="flex items-center rounded-md border border-[var(--style-border)] bg-[var(--style-surface)] p-0.5 backdrop-blur-sm"
      role="group"
      aria-label="Visual style"
    >
      {OPTIONS.map((option) => {
        const active = style === option.id;
        return (
          <button
            key={option.id}
            type="button"
            onClick={() => setStyle(option.id)}
            aria-pressed={active}
            className={`
              rounded px-2.5 py-1.5 text-[10px] font-mono uppercase tracking-[0.15em] transition-all duration-200
              ${active
                ? option.id === "claude"
                  ? "bg-[#C9644A] text-white shadow-sm"
                  : "bg-[var(--style-accent-dim)] text-[var(--style-accent)]"
                : "text-style-muted hover:text-style-body"
              }
            `}
          >
            <span className="hidden sm:inline">{option.label}</span>
            <span className="sm:hidden">{option.short}</span>
          </button>
        );
      })}
    </div>
  );
}
